/* eslint-disable no-unused-vars */

import ParcelRatesTable from '../../components/ParcelRates/ParcelRatesTable';
import ParcelRatesEditTable from '../../components/ParcelRates/ParcelRatesEditTable';
import { userPermissions } from '../../constants/enums/Permissions';
import { currentUser } from '../../utils/Auth/auth';

const ParcelRates = ({ swalModal }) => {
  const writeAccess = currentUser?.parcelRates === userPermissions.write;
  return (
    <div>
      <div className="text-left text-blue-800">
        <div>
          <div className=" relative mb-[7rem]">
            {writeAccess ? <ParcelRatesEditTable /> : <ParcelRatesTable />}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ParcelRates;
